import { Pipe, PipeTransform } from '@angular/core';
import { IFilter } from '../models/filter.model';
import { findIndex } from 'lodash';
import { AnalyticsData, _ACTIONS } from '../providers/analytics';

@Pipe({
  name: 'filterArrayBy',
})

export class FilterArrayPipe implements PipeTransform {

  private currentValue = "";

  transform(items: any[], filters: IFilter[], value: string, trackingParams: { pageName: string, uidTrack: string }, ) {
    if (!items || !filters || !value) {
      return items;
    }
    if (value) {
      value = value.toLowerCase();
    }

    let elementsFiltered = [];

    for (let item of items) {
      let ponderation: any[] = [];
      for (let filterItem of filters) {
        if (filterItem.multiLanguage) {
          ponderation.push(this.checkMultiLanguage(item, filterItem, value));
        }
        else {
          ponderation.push(item[filterItem.filter].toString().toLowerCase().includes(value));
        }
      }
      if (findIndex(ponderation, (i) => i === true) != -1) {
        elementsFiltered.push(item);
      }
    }

    if (this.currentValue !== value) {
      this.analytics
        .savePageTrackOnFirestore(
          trackingParams.pageName,
          _ACTIONS.search,
          trackingParams.uidTrack,
          {
            search: value,
            numResults: elementsFiltered.length,
          },
        );
      this.currentValue = value;
    }

    return elementsFiltered;
  }

  private checkMultiLanguage(item, filterItem, value) {
    if (item[filterItem.filter]['en'].toLowerCase().includes(value) ||
      item[filterItem.filter]['es'].toLowerCase().includes(value)) {
      return true;
    } else {
      return false;
    }
  }

  constructor(
    private analytics: AnalyticsData,
  ) { }
}



// WEBPACK FOOTER //
// ./src/pipes/filter-array.pipe.ts